<div class="control-section">
  <ejs-grid #grid
            class="grid-with-footer"
            width="100%" rowHeight="38"
            [dataSource]="data"
            [allowSorting]="true"
            [searchSettings]="searchOptions"
            (actionComplete)="actionComplete($event)"
            (actionBegin)="actionBegin($event)"
            [filterSettings]="filterSettings"
            [allowFiltering]="true"
            [allowPaging]="true"
            [pageSettings]="pageSettings"
            (rowDataBound)="rowDataBound($event)"
            (commandClick)="commandClick($event)">
    <e-columns>
      <e-column field="id" [visible]="false" headerText="id" [isPrimaryKey]="true"></e-column>
      @if (isAdmin || !issuedToMe) {
        <e-column field="parkerAlias" type="string" headerText="{{'i18n.domain.parking-card.grid.name' | translate}}" clipMode="EllipsisWithTooltip"></e-column>
        <e-column field="issuedToUserName" type="string" headerText="{{'i18n.domain.parking-card.grid.issued-to' | translate}}" clipMode="EllipsisWithTooltip"></e-column>
      } @else {
        <e-column field="visitorAlias" type="string" headerText="{{'i18n.domain.parking-card.grid.name' | translate}}" clipMode="EllipsisWithTooltip"></e-column>
      }
      <e-column field="issuingParkerName" type="string" headerText="{{'i18n.domain.parking-card.grid.issuing-parker' | translate}}" clipMode="EllipsisWithTooltip"></e-column>
      <e-column field="controlPlateNumber" type="string" headerText="{{'i18n.domain.parking-card.grid.control-plate' | translate}}" clipMode="EllipsisWithTooltip"></e-column>
      <e-column field="validFromDateTime" headerText="{{'i18n.domain.parking-card.grid.valid-from' | translate}}" width="140px" type="date" [filter]="dateFilter" clipMode="EllipsisWithTooltip">
        <ng-template #template let-data>
          {{data?.validFromDateTime | date:'dd.MM.yyyy'}}
        </ng-template>
      </e-column>
      <e-column field="validToDateTime" headerText="{{'i18n.domain.parking-card.grid.valid-to' | translate}}" width="140px" type="date" [filter]="dateFilter" clipMode="EllipsisWithTooltip">
        <ng-template #template let-data>
          {{data?.validToDateTime | date:'dd.MM.yyyy'}}
        </ng-template>
      </e-column>
      <e-column field="forMultipleUse" headerText="{{'i18n.domain.parking-card.grid.multiple-use' | translate}}" width="160px" [defaultValue]="true" [filter]="isActiveFilter">
        <ng-template #filterItemTemplate let-data>{{formatIsActive(data, 'forMultipleUse')}}</ng-template>
        <ng-template #template let-data>
          <span class="e-icons" [class.icon-checkmark]="data?.forMultipleUse"></span>
        </ng-template>
      </e-column>
      <e-column field="lastUsedOn" headerText="{{'i18n.domain.parking-card.grid.last-used-on' | translate}}" type="date" [filter]="dateFilter" clipMode="EllipsisWithTooltip">
        <ng-template #template let-data>
          {{data?.lastUsedOn | date:'dd.MM.yyyy HH:mm:ss'}}
        </ng-template>
      </e-column>
      <e-column field="clientName" type="string" headerText="{{'i18n.domain.parking-card.grid.client-name' | translate}}" clipMode="EllipsisWithTooltip"></e-column>
      <e-column field="isActive" headerText="{{'i18n.shared.fields.active' | translate}}" width="120px" [defaultValue]="true" [filter]="isActiveFilter">
        <ng-template #filterItemTemplate let-data>{{formatIsActive(data, 'isActive')}}</ng-template>
        <ng-template #template let-data>
          <span class="e-icons" [class.icon-checkmark]="data.isActive"></span>
        </ng-template>
      </e-column>
      @if(!issuedToMe){
        <e-column headerText="" [commands]="gridCommands" width="40px"></e-column>
      }
    </e-columns>
  </ejs-grid>
</div>
